import React from 'react';
import { Flex } from 'antd';
import { useFormik } from 'formik';

import {
    AutoBroadcast,
    autoBroadcastType,
    AutoBroadcastValues,
} from '../service/autoBroadcast.interface';
import { Save } from '../../../../shops/widgets/Save';
import {
    validationSchema,
    getFormFields,
    getInitialValues,
} from '../utils/fields';
import { useAppSelector } from '../../../../../store';
import { selectAutoBroadcastByType } from '../store/autoBroadcastsSlice';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';
import { useApiSuccessNotification } from '../../../../../hooks/useApiSuccessNotification';
import { createFormData } from '../../../../../utils/common/createFormData';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { useCreateAutoBroadcastSettingsMutation } from '../service/autoBroadcasts.api';

export const AutoBroadcastDropSessionContainer = () => {
    const current = useAppSelector(selectShopCurrent);

    const dropSessionSettings = useAppSelector(state =>
        selectAutoBroadcastByType(
            state,
            autoBroadcastType.no_order as AutoBroadcast
        )
    );

    const [createBroadcast, { isLoading, isSuccess, isError, error, data }] =
        useCreateAutoBroadcastSettingsMutation();

    useApiErrorNotification(isError, error);
    useApiSuccessNotification(isSuccess, data);

    const onSave = async (values: AutoBroadcastValues): Promise<void> => {
        const payload = {
            ...values,
        };

        if (typeof values.image === 'string') {
            delete payload.image;
        }

        await createBroadcast({
            shop_id: current.id,
            payload: createFormData(payload),
        });
    };

    const formFields = getFormFields(autoBroadcastType.no_order);
    const initialValues =
        dropSessionSettings ?? getInitialValues(autoBroadcastType.no_order);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: onSave,
    });

    return (
        <>
            <Flex vertical gap={16}>
                {formFields.map(({ component: Component, ...field }) => (
                    <Component
                        key={field.fieldName}
                        formik={formik}
                        {...field}
                    />
                ))}
            </Flex>

            <Save
                backRoute={'/app/crm/auto-broadcasts'}
                loading={isLoading}
                onSave={() => onSave(formik.values)}
                disabled={false}
            />
        </>
    );
};
